module.exports = __webpack_public_path__ + "static/media/desktop-menu.d713e344.svg";